import { type FC } from 'react';

// MUI
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

// screen
import { NORMAL_FONT_SIZE, RenderedCell } from 'modules/map/components/pdf-print-form/utils';
import StyledTableHead from 'modules/map/components/pdf-print-form/styled-components/StyledTableHead';
import StyleTableHeadCellText from 'modules/map/components/pdf-print-form/styled-components/StyleTableHeadCellText';
import SizedText from 'modules/map/components/pdf-print-form/styled-components/SizedText';

interface PdfTableHeaderProps {
  firstRow: RenderedCell[];
  secondRow?: RenderedCell[];
  firstRowCustomStyle?: React.CSSProperties;
  secondRowCustomStyle?: React.CSSProperties;
}

const PdfTableHeader: FC<PdfTableHeaderProps> = (props) => {
  const { firstRow, secondRow = [], firstRowCustomStyle, secondRowCustomStyle } = props;

  return (
    <StyledTableHead>
      <TableRow sx={{ height: secondRow.length === 0 ? 96 : 'auto' }}>
        {firstRow.map((item, index) => (
          <TableCell
            key={index}
            rowSpan={item.rowSpan}
            colSpan={item.colSpan}
            className="whitespace-pre-wrap"
            style={{ width: item.width }}
          >
            <StyleTableHeadCellText label={item.label} sx={firstRowCustomStyle} />
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        {secondRow.map((item, index) => (
          <TableCell
            key={index}
            rowSpan={item.rowSpan}
            style={{ width: item.width, height: NORMAL_FONT_SIZE }}
          >
            <SizedText
              sx={{
                fontSize: NORMAL_FONT_SIZE,
                fontWeight: 600,
                ...secondRowCustomStyle,
              }}
            >
              {item.label}
            </SizedText>
          </TableCell>
        ))}
      </TableRow>
    </StyledTableHead>
  );
};

export default PdfTableHeader;
